(function () {
  'use strict';

  /* @ngdoc object
   * @name airports
   * @description
   *
   */
  angular
    .module('airport', [
      'ui.router'
    ]);
}());
